function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IcautionCircleRed = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    notChangeable: true,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.00035 11.9333C2.0448 6.46667 6.51131 2 12 2C17.5776 2.04444 22.0441 6.55556 21.9997 12.0667C21.9552 17.5333 17.4887 22 12 22H11.9333C9.26677 21.9778 6.75575 20.9333 4.88915 19.0222C3.00032 17.1333 1.97813 14.6 2.00035 11.9333Z",
    fill: "#E4464A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.181C11.3793 14.181 10.875 14.692 10.875 15.3209V15.3602C10.875 15.989 11.3793 16.5 12 16.5C12.6207 16.5 13.125 15.989 13.125 15.3602V15.3209C13.125 14.692 12.6207 14.181 12 14.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5C11.3793 7.5 10.875 8.01096 10.875 8.63984V11.9021C10.875 12.531 11.3793 13.042 12 13.042C12.6207 13.042 13.125 12.531 13.125 11.9021V8.63984C13.125 8.01096 12.6207 7.5 12 7.5Z",
    fill: "white"
  }));
});